import { render } from "./ActivityIndex.vue?vue&type=template&id=8d47f6fe"
import script from "./ActivityIndex.vue?vue&type=script&lang=js"
export * from "./ActivityIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__